export default "__VITE_ASSET__C1NuOdk9__"